"use client";

import type { FC, Ref } from "react";
import {
  SummaryCard,
  type SummaryCardProps,
  type TableDataWithStyling,
  type ValueType,
} from "@huub-web/ui";

type SummaryCardTemplatePropsType = Pick<
  SummaryCardProps,
  "title" | "value" | "columns"
> & {
  data: {
    title: string;
    value: ValueType;
  }[];
};

export interface SummaryCardTemplateProps
  extends SummaryCardTemplatePropsType {}

/**
 * A template for a summary card.
 * @deprecated 💀
 */
export const SummaryCardTemplate: FC<
  SummaryCardTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ title, value, data, columns, ref }) => {
  const parsedData: TableDataWithStyling = {
    headings: data?.map(({ title }) => ({ name: title })) ?? [],
    rows: [
      {
        values:
          data?.map(({ value }) => ({
            value,
          })) ?? [],
      },
    ],
  };

  return (
    <SummaryCard
      ref={ref}
      title={title}
      value={value}
      data={parsedData}
      columns={columns}
    />
  );
};
